import React, { useMemo, useState, useEffect } from "react";

import BlogCard from "../BlogCard/BlogCard";

import { ArrowsWithNumber } from "../../../../common/ArrowsWithNumber/ArrowsWithNumber";

import { useTranslation } from "next-i18next";
import { useQuery } from "@apollo/client";
import { GET_BLOGS } from "../../../../../graphql/queries/queriesNews";

const MEDIA_SIZES = [
  { firstSize: 0, lastSize: 500, count: 1 },
  { firstSize: 500, lastSize: 1000, count: 2 },
  { firstSize: 1000, lastSize: +Infinity, count: 3 },
];

const BlogSection = ({ color }) => {
  const [t] = useTranslation();

  const { data: { blogs = [] } = {} } = useQuery(GET_BLOGS);

  // обьект -сколько ел отображать
  const [activeMediaSize, setActiveMediaSize] = useState(null);

  useEffect(() => {
    const windowWidth = document.body.offsetWidth;

    const activeMediaEl = MEDIA_SIZES.find(
      ({ firstSize, lastSize }) =>
        windowWidth > firstSize && windowWidth <= lastSize
    );

    setActiveMediaSize(activeMediaEl);
  }, []);
  // при resize проверяем нужно ли поменять сколько ел отображать
  useEffect(() => {
    if (!activeMediaSize) return;

    const resizeFunc = () => {
      const windowWidth = document.body.offsetWidth;

      if (
        windowWidth > activeMediaSize.lastSize ||
        windowWidth < activeMediaSize.firstSize
      ) {
        const activeMediaEl = MEDIA_SIZES.find(
          ({ firstSize, lastSize }) =>
            windowWidth > firstSize && windowWidth <= lastSize
        );

        setActiveMediaSize(activeMediaEl);
      }
    };

    window.addEventListener("resize", resizeFunc);

    return () => window.removeEventListener("resize", resizeFunc);
  }, [activeMediaSize]);

  // общее количество всех страниц продуктов и активная страница
  const [lengthOfPages, setLengthOfPages] = useState(null);
  const [numberOfPage, setNumberOfPage] = useState(1);

  useEffect(() => {
    if (activeMediaSize === null) return;

    const lengthPages =
      blogs.length === 0 ? 0 : Math.ceil(blogs.length / activeMediaSize.count);

    setLengthOfPages(lengthPages);

    if (lengthPages && numberOfPage > lengthPages) setNumberOfPage(lengthPages);
  }, [blogs, activeMediaSize]);

  const { prevPage, nextPage } = useMemo(
    () => ({
      prevPage: () => setNumberOfPage((s) => (s <= 1 ? 1 : numberOfPage - 1)),

      nextPage: () =>
        setNumberOfPage((s) =>
          s >= lengthOfPages ? lengthOfPages : numberOfPage + 1
        ),
    }),
    [lengthOfPages]
  );

  // список продуктов с учетом активной страницы и количества ел на странице

  const allBlogsForReturn = useMemo(() => {
    if (!activeMediaSize) return [];

    const { count } = activeMediaSize;

    return blogs.filter((el, id) => {
      if (id >= (numberOfPage - 1) * count && id < numberOfPage * count)
        return el;
    });
  }, [blogs, numberOfPage, activeMediaSize]);

  return (
    <>
      {blogs?.length ? (
        <section className="club-blog club-page--background">
          <div className="container">
            <div className="club-arrow-title-block club-blog-title-block">
              <h2 className="club-page-title ">{t("blog")}</h2>

              {lengthOfPages > 1 && (
                <ArrowsWithNumber
                  numberOfPage={numberOfPage}
                  lengthOfPages={lengthOfPages}
                  onPrev={prevPage}
                  onNext={nextPage}
                />
              )}
            </div>

            <div className="card-media-size-wrapper ">
              {allBlogsForReturn.map(
                ({ coverImage, date, id, slug, title, subtitle }) => (
                  <div
                    key={id}
                    className={
                      activeMediaSize?.count
                        ? `card-media-size-${activeMediaSize.count}`
                        : ""
                    }
                  >
                    <BlogCard
                      key={id}
                      coverImage={coverImage}
                      date={date}
                      slug={slug}
                      title={title}
                      subtitle={subtitle}
                      color={color}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </section>
      ) : null}
      <style jsx global>{`
        @import "./BlogSection.scss?7";
        @import "../PerspectiveCard/CardMedia.scss";
      `}</style>
    </>
  );
};

export default BlogSection;
